'use client'

import { motion } from 'framer-motion'
import Link from 'next/link'



export default function Header() {
  return (
    <header className='py-8 px-6 font-black text-5xl font-stix fixed z-50 select-none'>
      <motion.div
        whileHover={{ scale: 1.2 }}
        whileTap={{
          scale: 0.8,
          rotate: 30,
        }}
      >
        <Link href='/'>
          W
        </Link>
      </motion.div>
    </header>
  )
}
